import AbstractCrudService from "@/service/v3/AbstractCrudService";
import HttpService from "@/service/HttpService";

class OwnerService extends AbstractCrudService {
    constructor() {
        super("/owner");
    }
    getAll() {
        return HttpService.backApi.get(`/owner`)
    }
}

export default new OwnerService();